import {Controller} from "@hotwired/stimulus"
// Connects to data-controller="tooltip"

export default class TooltipController extends Controller {
    connect() {
        if (globalThis.AppConfig.isDesktop) {
            document.addEventListener("click", this.closeTooltip.bind(this));
        }
        $('.tooltip').not(this).remove();
        this.tooltip = new bootstrap.Tooltip(this.element, {
            boundary: document.body, // or document.querySelector('#boundary')
            sanitize: false
        })
    }

    closeTooltip(e) {
        this.tooltip.hide();
    }
}